import React, { useRef } from 'react';
import arrows from '../img/arrows.svg';
import gsap from 'gsap';

const ScrollButton = React.forwardRef(({ text, id, className}, ref) => {
  return (
    <div id={id} ref={ref} className={`opacity-0 fixed w-full h-full bottom-4 left-0 flex flex-row justify-center items-end pointer-events-none z-10 ${className}`}>
      <div className="flex flex-col">
        <span className="uppercase font-thin text-white">{text}</span>
        <img  src={arrows} alt="arrows" className="continue-arrow block m-auto"/>
      </div>
    </div>
  );
});

export default ScrollButton;
